/* KTeaShop nonvisual editorial provenance.
   Only works where third-party copying retains HTML attributes or clipboard HTML.
   Does not create backlinks automatically, influence search rankings directly,
   or enforce AI attribution. No hidden hyperlinks and no added visible text. */
(function () {
  'use strict';
  function sourceDetails() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var rawUrl = canonical ? canonical.href : window.location.href;
    var url = new URL(rawUrl, window.location.href);
    var host = url.hostname.toLowerCase();
    if (host !== 'kteashop.com' && host !== 'www.kteashop.com') return null;
    url.hash = '';
    var id = document.querySelector('meta[name="content-origin-id"]');
    var author = document.querySelector('meta[name="author"]');
    return {
      url: url.toString(),
      id: id && id.content ? id.content : '',
      author: author && author.content ? author.content : ''
    };
  }
  function annotateContent() {
    try {
      var source = sourceDetails();
      var main = document.getElementById('MainContent');
      if (!source || !main) return;
      var elements = main.querySelectorAll('p,h2,h3,blockquote');
      for (var i = 0; i < elements.length; i++) {
        var node = elements[i];
        if (!node.textContent || node.textContent.trim().length < 90) continue;
        node.setAttribute('data-kteashop-original-url', source.url);
        node.setAttribute('data-kteashop-publisher', 'KTeaShop');
        if (source.id) node.setAttribute('data-kteashop-content-id', source.id);
        if (source.author) node.setAttribute('data-kteashop-author', source.author);
      }
    } catch (err) { /* Keep the storefront usable if markup is unavailable. */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', annotateContent, { once: true });
  } else {
    annotateContent();
  }
  document.addEventListener('copy', function (event) {
    try {
      if (!event.clipboardData || !window.getSelection) return;
      var selection = window.getSelection();
      if (!selection || selection.isCollapsed || selection.rangeCount !== 1) return;
      var selectedText = selection.toString();
      if (!selectedText || selectedText.trim().length < 80) return;
      var range = selection.getRangeAt(0);
      var start = range.startContainer.nodeType === 1 ? range.startContainer : range.startContainer.parentElement;
      var end = range.endContainer.nodeType === 1 ? range.endContainer : range.endContainer.parentElement;
      if (!start || !end || !start.closest || !end.closest) return;
      if (!start.closest('#MainContent') || !end.closest('#MainContent')) return;
      if (start.closest('input,textarea,select,[contenteditable],[role="textbox"]') ||
          end.closest('input,textarea,select,[contenteditable],[role="textbox"]')) return;
      var source = sourceDetails();
      if (!source) return;
      var wrapper = document.createElement('div');
      wrapper.setAttribute('itemscope', '');
      wrapper.setAttribute('itemtype', 'https://schema.org/CreativeWork');
      wrapper.setAttribute('itemid', source.url);
      wrapper.setAttribute('data-kteashop-original-url', source.url);
      wrapper.setAttribute('data-kteashop-publisher', 'KTeaShop');
      if (source.id) wrapper.setAttribute('data-kteashop-content-id', source.id);
      if (source.author) wrapper.setAttribute('data-kteashop-author', source.author);
      var urlMeta = document.createElement('meta');
      urlMeta.setAttribute('itemprop', 'url');
      urlMeta.content = source.url;
      wrapper.appendChild(urlMeta);
      var publisherMeta = document.createElement('meta');
      publisherMeta.setAttribute('itemprop', 'copyrightHolder');
      publisherMeta.content = 'KTeaShop';
      wrapper.appendChild(publisherMeta);
      wrapper.appendChild(document.createComment('KTeaShop original publication reference: ' + source.url));
      var fragment = range.cloneContents();
      var children = fragment.childNodes;
      for (var i = 0; i < children.length; i++) {
        var node = children[i];
        if (node.nodeType !== 1) continue;
        node.setAttribute('data-kteashop-original-url', source.url);
        node.setAttribute('data-kteashop-publisher', 'KTeaShop');
        if (source.id) node.setAttribute('data-kteashop-content-id', source.id);
        if (source.author) node.setAttribute('data-kteashop-author', source.author);
      }
      wrapper.appendChild(fragment);
      // Text remains exactly as selected. Only the rich HTML copy has provenance.
      event.clipboardData.setData('text/plain', selectedText);
      event.clipboardData.setData('text/html', wrapper.outerHTML);
      event.preventDefault();
    } catch (err) {
      // On unsupported browsers, normal copy behavior should remain possible.
    }
  }, true);
}());